import { Channel, Member, Role, Team } from "types";
import permissions from "./channelPermissions";
import { QueryObserverResult } from "@tanstack/react-query";

export default function getPermissionsById({
    teamData,
    userId,
    channelData,
    members,
    roles,
}: {
    teamData: QueryObserverResult<{ team: Team }, Error>;
    userId: string;
    channelData: Channel;
    members: { members: Member[] };
    roles: Role[];
}) {
    if (!teamData || !channelData || !members?.members || !roles) return { allow: [], deny: [] };
    const team = teamData.data?.team;
    if (team?.createdBy === userId) {
        return {
            allow: (Object.keys(permissions[channelData.type as keyof typeof permissions] || {})),
            deny: [],
        };
    }
    const userRoles = Array.isArray(members?.members) ? members.members.find((member) => member.id === userId)?.roles || [] : [];
    let perms = BigInt(0);
    let denyPerms = BigInt(0);
        
    const userPermissions = channelData.permissions?.user?.[userId];
    if (userPermissions) {
        perms |= BigInt(userPermissions.allow);
        denyPerms |= BigInt(userPermissions.deny);
    }

    const sortedRoles = roles
        .filter((role) => userRoles.includes(role.id))
        .sort((a, b) => b.priority - a.priority);

    for (const role of sortedRoles) {
        const rolePermissions = channelData.permissions?.role?.[role.id];
        if (rolePermissions) {
            perms |= BigInt(rolePermissions.allow);
            
            denyPerms |= BigInt(rolePermissions.deny) & ~ perms;
        }
    }   

    const rolePerms = sortedRoles.reduce((acc, role) => acc | BigInt(role.permissions), BigInt(0));
    perms |= rolePerms;

    const result: any = { allow: [], deny: [] };
    const channelPermissions = permissions[channelData.type as keyof typeof permissions] || {};

    for (const role of sortedRoles) {
        //@ts-ignore
        if(BigInt(role.permissions) & BigInt(1n << 1n) && !(denyPerms & BigInt(permissions?.[channelData.type]?.["MANAGE_CHANNEL"]?.value))) {
            result.allow.push("MANAGE_CHANNEL");
        }
        //@ts-ignore
        if(channelData.type != "text") continue;
        if(BigInt(role.permissions) & BigInt(1n << 6n) && !(denyPerms & BigInt(permissions?.[channelData.type]?.["MANAGE_MESSAGES"]?.value))) {
            result.allow.push("MANAGE_MESSAGES");
        }
    }

    for (const [key, value] of Object.entries(channelPermissions)) {
        const permValue = BigInt(value.value);
        if ((perms & permValue) && !(denyPerms & permValue)) {
            result.allow.push(key);
        } else if (denyPerms & permValue) {
            result.deny.push(key);
        }
    }

    //@ts-ignore
    const defaults = permissions.defaults[channelData.type]  || BigInt(0);
    for (const [key, value] of Object.entries(channelPermissions)) {
        const permValue = BigInt(value.value);
        if ((defaults & permValue) && !(denyPerms & permValue)) {
            result.allow.push(key);
        }
    }
    


    return result;
}
